/**
 * UnderservedPopulationGrowthChart — NOT_CONNECTED
 *
 * Population growth trend requires LOS integration for borrower tracking.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const UnderservedPopulationGrowthChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.los}
      metricName="Underserved Population Growth"
    />
  );
};

export default UnderservedPopulationGrowthChart;